import _Reflect$construct from '@babel/runtime-corejs3/core-js/reflect/construct';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js/instance/trim';
import _parseInt from '@babel/runtime-corejs3/core-js/parse-int';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js/instance/reduce';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import * as React from 'react';
import classNames from 'classnames';
import { isEqual } from 'lodash-es';
import { prependPrefix } from '../../utils/style.js';
import { getPagination } from './utils.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @deprecated 新版可以用 e.key === 'Enter' 来判断 */

var ENTER_KEY_CODE = 13;
var typesShouldBeCentered = ['small', 'small-square'];
var typesShouldBeSmall = ['small', 'small-square'];
var LegacyPagination = /*#__PURE__*/function (_React$Component) {
  _inherits(LegacyPagination, _React$Component);

  var _super = _createSuper(LegacyPagination);

  function LegacyPagination(props) {
    var _this;

    _classCallCheck(this, LegacyPagination);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "gotoInputRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (content, defaultContent, page) {
      // 没有提供自定义内容，则显示默认文案
      if (typeof content === 'undefined') {
        return defaultContent;
      } // Render Function


      if (typeof content === 'function' && page !== undefined) {
        return content(page);
      }

      return content;
    });

    _defineProperty(_assertThisInitialized(_this), "handlePageSelect", function (page, disabled) {
      var _this$props$onPageCha, _this$props;

      if (disabled) return;
      (_this$props$onPageCha = (_this$props = _this.props).onPageChange) === null || _this$props$onPageCha === void 0 ? void 0 : _this$props$onPageCha.call(_this$props, page);
    });

    _defineProperty(_assertThisInitialized(_this), "handleGotoKeyDown", function (e) {
      if (!_this.gotoInputRef.current) return;
      var keyCode = e.keyCode || e.which;

      if (keyCode === ENTER_KEY_CODE) {
        var _context;

        var pageVal = _trimInstanceProperty(_context = _this.gotoInputRef.current.value).call(_context);

        if (pageVal) {
          var page_count = _this.props.pagination.page_count;

          var pageNum = _parseInt(pageVal);

          if (pageNum >= 1 && pageNum <= page_count) {
            _this.handlePageSelect(pageNum);
          }
        }

        _this.gotoInputRef.current.value = '';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleGotoChange", function (e) {
      var page_count = _this.props.pagination.page_count;

      var page = _parseInt(e.target.value);

      if (!page || page <= 0) {
        e.target.value = '1';
      } else if (page > page_count) {
        e.target.value = "".concat(page_count);
      }
    });

    var _this$props$paginatio = _this.props.pagination,
        _page = _this$props$paginatio.page,
        _page_count = _this$props$paginatio.page_count;
    _this.state = {
      pagination: getPagination(_page, _page_count, !!_this.props.type && _includesInstanceProperty(typesShouldBeCentered).call(typesShouldBeCentered, _this.props.type))
    };
    return _this;
  }

  _createClass(LegacyPagination, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: // eslint-disable-next-line @typescript-eslint/naming-convention
    function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!isEqual(this.props.pagination, nextProps.pagination)) {
        var _nextProps$pagination = nextProps.pagination,
            page = _nextProps$pagination.page,
            page_count = _nextProps$pagination.page_count;
        this.setState({
          pagination: getPagination(page, page_count, nextProps.type === 'small')
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var pageDoms = [];
      var type = this.props.type;
      var pagination = this.state.pagination;
      var settings = this.props.settings || {};

      var isSmallType = !!type && _includesInstanceProperty(typesShouldBeSmall).call(typesShouldBeSmall, type);
      /* start */


      if (isSmallType) {
        if (!settings.hideGoto) {
          pageDoms.push( /*#__PURE__*/React.createElement("li", {
            key: pageDoms.length,
            className: "pagination-goto"
          }, /*#__PURE__*/React.createElement("span", {
            className: "gotopage"
          }, this.renderItem(settings.gotoContent, "\u5171 ".concat(pagination.count, " \u9875"), pagination.count))));
        }

        if (!settings.hideBegin && !pagination.disableBegin) {
          pageDoms.push( /*#__PURE__*/React.createElement("li", {
            key: pageDoms.length,
            className: "page begin",
            title: "\u7B2C 1 \u9875",
            onClick: function onClick() {
              return _this2.handlePageSelect(1);
            }
          }, this.renderItem(settings.beginContent, '首页')));
        }

        if (!settings.hidePre && pagination.showPre) {
          pageDoms.push( /*#__PURE__*/React.createElement("li", {
            key: pageDoms.length,
            className: "page previous",
            title: "\u4E0A\u4E00\u9875",
            onClick: function onClick() {
              return _this2.handlePageSelect(pagination.current - 1);
            }
          }, this.renderItem(settings.preContent, '上页')));
        }
      } else {
        if (!settings.hidePre) {
          pageDoms.push( /*#__PURE__*/React.createElement("li", {
            key: pageDoms.length,
            className: classNames('page previous', {
              disable: !pagination.showPre
            }),
            onClick: function onClick() {
              return _this2.handlePageSelect(pagination.current - 1, !pagination.showPre);
            }
          }, this.renderItem(settings.preContent, '< 前页')));
        }

        if (pagination.start > 1) {
          pageDoms.push( /*#__PURE__*/React.createElement("li", {
            key: pageDoms.length,
            className: classNames('page begin', {
              disable: pagination.disableBegin
            }),
            title: "\u7B2C 1 \u9875",
            onClick: function onClick() {
              return _this2.handlePageSelect(1, pagination.disableBegin);
            }
          }, "1"));

          if (pagination.start > 2) {
            pageDoms.push( /*#__PURE__*/React.createElement("li", {
              key: pageDoms.length,
              className: "ellipsis"
            }, "..."));
          }
        }
      }
      /* pages */


      var _loop = function _loop(i) {
        pageDoms.push( /*#__PURE__*/React.createElement("li", {
          key: pageDoms.length,
          className: classNames('page', {
            active: i === pagination.current
          }),
          title: "\u7B2C ".concat(i, " \u9875"),
          onClick: function onClick() {
            return _this2.handlePageSelect(i, i === pagination.current);
          }
        }, i));
      };

      for (var i = pagination.start; i <= pagination.end; i++) {
        _loop(i);
      }
      /* end */


      if (isSmallType) {
        if (!settings.hideNext && pagination.showNext) {
          pageDoms.push( /*#__PURE__*/React.createElement("li", {
            key: pageDoms.length,
            className: "page next",
            title: "\u4E0B\u4E00\u9875",
            onClick: function onClick() {
              return _this2.handlePageSelect(pagination.current + 1);
            }
          }, this.renderItem(settings.nextContent, '下页')));
        }

        if (!settings.hideLast && !pagination.disableLast) {
          pageDoms.push( /*#__PURE__*/React.createElement("li", {
            key: pageDoms.length,
            className: "page last",
            title: "\u7B2C ".concat(pagination.count, " \u9875"),
            onClick: function onClick() {
              return _this2.handlePageSelect(pagination.count);
            }
          }, this.renderItem(settings.lastContent, '末页')));
        }
      } else {
        if (pagination.end < pagination.count) {
          if (pagination.end < pagination.count - 1) {
            pageDoms.push( /*#__PURE__*/React.createElement("li", {
              key: pageDoms.length,
              className: "ellipsis"
            }, "..."));
          }

          pageDoms.push( /*#__PURE__*/React.createElement("li", {
            key: pageDoms.length,
            className: classNames('page last', {
              disable: pagination.disableLast
            }),
            title: "\u7B2C ".concat(pagination.count, " \u9875"),
            onClick: this.handlePageSelect.bind(this, pagination.count, pagination.disableLast)
          }, pagination.count));
        }

        if (!settings.hideNext) {
          pageDoms.push( /*#__PURE__*/React.createElement("li", {
            key: pageDoms.length,
            className: classNames('page next', {
              disable: !pagination.showNext
            }),
            onClick: this.handlePageSelect.bind(this, pagination.current + 1, !pagination.showNext)
          }, this.renderItem(settings.nextContent, '后页 >')));
        }

        if (!settings.hideGoto) {
          pageDoms.push( /*#__PURE__*/React.createElement("li", {
            key: pageDoms.length,
            className: "pagination-goto"
          }, /*#__PURE__*/React.createElement("span", {
            className: "gotopage"
          }, this.renderItem(settings.gotoContent, "\u5171 ".concat(pagination.count, " \u9875\uFF0C\u8DF3\u8F6C\u5230"), pagination.count)), /*#__PURE__*/React.createElement("input", {
            title: "\u9875\u7801",
            ref: this.gotoInputRef,
            type: "number",
            className: "gotopage-input",
            onKeyDown: this.handleGotoKeyDown,
            onChange: this.handleGotoChange
          }), /*#__PURE__*/React.createElement("span", null, "\u9875")));
        }
      }

      return /*#__PURE__*/React.createElement("ul", {
        className: classNames(prependPrefix('legacy-pagination'), 'main-site', type || 'ajax')
      }, _reduceInstanceProperty(pageDoms).call(pageDoms, function (p, c) {
        var _context2;

        return _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(p), [c, '\n']);
      }, []));
    }
  }]);

  return LegacyPagination;
}(React.Component);

export { LegacyPagination };
